import type { GeographicAreaType } from "@remi/types/geographicArea";

import { hasCapability, type User } from "../base";

export const geographicArea = {
  read: (user: User, type: GeographicAreaType, contractorProfileId?: string) => {
    switch (type) {
      case "service_areas":
        if (hasCapability(user, "geographicArea.read.serviceAreas")) {
          return true;
        }
        if (contractorProfileId) {
          return (
            user.person.organizationId === contractorProfileId &&
            hasCapability(user, "geographicArea.read.serviceAreas.own")
          );
        }
        return false;
      case "markets":
      case "regions":
      case "materials_regions":
        return hasCapability(user, "geographicArea.read");
    }
  },
  readCountyOverlay: (user: User) => {
    return hasCapability(user, "geographicArea.readCountyOverlay");
  },
  readStateOverlay: (user: User) => {
    return hasCapability(user, "geographicArea.readStateOverlay");
  },
  update: (user: User, type: GeographicAreaType, contractorProfileId?: string) => {
    switch (type) {
      case "service_areas": {
        if (!hasCapability(user, "geographicArea.update.serviceAreas")) {
          return false;
        }
        // The update capability has no unscoped/own split; the unscoped read capability marks the Remi-internal tier.
        if (hasCapability(user, "geographicArea.read.serviceAreas")) {
          return true;
        }
        return Boolean(contractorProfileId) && user.person.organizationId === contractorProfileId;
      }
      case "markets":
        return hasCapability(user, "geographicArea.update.markets");
      case "regions":
        return hasCapability(user, "geographicArea.update.regions");
      case "materials_regions":
        return hasCapability(user, "geographicArea.update.regions"); // also covers materials_regions — intentionally shares REMI_ADMIN gate
    }
  },
};
